import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { SelectModule } from 'ng2-select';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AgePipe } from './age-pipe';
import { LoadingDirective } from './button-loading.directive';
import { DirectMsgPipe } from './direct-msg-time';
import { ErrorsComponent } from './errors/errors.component';
import { FromNowPipe } from './fromNow.pipe';
import { GetGreetingTime } from './get-greeting-time';
import { HostnamePipe } from './host-name.pipe';
import { EscapeHtmlPipe } from './keep-html';
import { LineBreaksPipe } from './line-breaks';
import { MDatePipe } from './mdate.pipe';

import { ScaleOfNumbersPipe } from './million-billion-trillion-quad.pipe';
import { MoneyPipe } from './money.pipe';
import { NumberPipe } from './number.pipe';
import { NumberAbbr } from './numberAbbr';
import { OrderByPipe } from './order-by.pipe';
import { SelectWrapComponent } from './select-wrap/select-wrap.component';
import { SlideDirective } from './slide.directive';
import { Slide2Directive } from './slide2.directive';
import { TimeAgoPipe } from './time-ago.pipe';
import { UploadComponent } from './upload/upload.component';
import { YearsAgoPipe } from './years-ago.pipe';
import { SCodePipe } from './formatStockCode.pipe';
import { WebcamModule } from 'ngx-webcam';
import { WebCamComponent } from './web-cam/web-cam.component';
import { NumberCommaDirective } from './number-comma.pipe';

// import { ScrolledToBottomDirective } from './scrolled-to-bottom.directive';

@NgModule({
  imports: [CommonModule, DropDownsModule, WebcamModule, FormsModule, ReactiveFormsModule],
  declarations: [
    LoadingDirective,
    ErrorsComponent,
    SlideDirective,
    UploadComponent,
    TimeAgoPipe,
    DirectMsgPipe,
    HostnamePipe,
    OrderByPipe,
    AgePipe,
    YearsAgoPipe,
    EscapeHtmlPipe,
    LineBreaksPipe,
    SelectWrapComponent,
    GetGreetingTime,
    MoneyPipe,
    NumberPipe,
    NumberAbbr,
    MDatePipe,
    SCodePipe,
    FromNowPipe,
    Slide2Directive,
    ScaleOfNumbersPipe,
    WebCamComponent,
    NumberCommaDirective
    // ScrolledToBottomDirective
  ],
  providers: [],
  exports: [
    LoadingDirective,
    ErrorsComponent,
    SlideDirective,
    UploadComponent,
    TimeAgoPipe,
    AgePipe,
    YearsAgoPipe,
    DirectMsgPipe,
    HostnamePipe,
    EscapeHtmlPipe,
    LineBreaksPipe,
    SelectWrapComponent,
    GetGreetingTime,
    OrderByPipe,
    MoneyPipe,
    NumberPipe,
    NumberAbbr,
    MDatePipe,
    SCodePipe,
    FromNowPipe,
    Slide2Directive,
    ScaleOfNumbersPipe,
    WebCamComponent,
    NumberCommaDirective
    // ScrolledToBottomDirective
  ],
})
export class UtilsModule {}
